
import { Component, Prop, Vue } from "vue-property-decorator";
import Typewriter from "./Typewriter.vue";
import { Storylines, Inventory } from "../scenes/models";

@Component({
  components: { Typewriter },
})
export default class Hints extends Vue {
  pin = '';

  checkPin() {
    if(this.pin === "9798") {
      this.$emit('success')
    } else {
      this.$emit('fail')
    }
  }
}
